module.exports = __webpack_public_path__ + "img/account.9534e2e4.png";